import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Col, Table } from "reactstrap";
import { H5 } from "../../../AbstractElements";
import {
  ExpiredSubscription,
  Name,
  CompanyName,
  Amount,
  Invoice,
  InvoiceDate,
} from "../../../Constant";
import HeaderCard from "../../Common/Component/HeaderCard";
import { Link } from "react-router-dom";
import { getExpireSub } from "../../../CommonURL";
import { getDataWithToken } from "../../../Utils/restUtils";
import { toast } from "react-toastify";

const ExpiredSub = ({ industryId, year }) => {
  const [expireData, setExpireData] = useState([]);

  useEffect(() => {
    ExpireData();
  }, [industryId, year]);

  const ExpireData = async () => {
    let url = getExpireSub;

    const params = [];
    if (industryId) params.push(`industry_type_id=${industryId}`);
    if (year) params.push(`year=${year}`);

    if (params.length) {
      url = `${getExpireSub}?${params.join("&")}`;
    }

    const data = await getDataWithToken(url);
    
    if (data.status) {
      setExpireData(data.data.data);
    } else {
      toast.error(data.data.message);
    }
  };

  return (
    <Fragment>
      <Col xs="12">
        <Card className="transaction-history" style={{ height: "400px" }}>
          <HeaderCard title={ExpiredSubscription} setting={true} />
          <CardBody>
            <div
              className="table-responsive sroller-style"
              style={{ height: "350px", overflowY: "auto" }}
            >
              <Table className="table table-bordernone table-responsive">
                <thead>
                  <tr>
                    <th>{Name}</th>
                    <th>Industry Name</th>
                    <th>{CompanyName}</th>
                    <th>{Invoice}</th>
                    <th>{Amount}</th>
                    <th>{InvoiceDate}</th>
                  </tr>
                </thead>
                <tbody>
                  {expireData.slice(0, 10).map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <Link
                            style={{ color: "#5F0F40", marginLeft: "13px" }}
                            to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${item.user_id}`}
                          >
                            <H5>{item.user_name}</H5>
                          </Link>
                        </td>
                        <td>
                          <H5>{item.industry_type_name}</H5>
                        </td>
                        <td>
                          <H5>{item.company}</H5>
                        </td>
                        <td>
                          <Link
                            to={`${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?id=${item.id}&order_id=${item.order_id}`}
                          >
                            {item.invoice_number}
                          </Link>
                        </td>
                        <td>
                          <H5>${item.amount}</H5>
                        </td>
                        <td>
                          <H5>{item.invoice_date}</H5>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <div className="text-end mt-3 pb-3">
                <Link
                  to={`${process.env.PUBLIC_URL}/subscriptions/expiredSubscription`}
                  style={{
                    color: "#5F0F40",
                    fontWeight: "600",
                    textDecoration: "none",
                  }}
                >
                  View More →
                </Link>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default ExpiredSub;
